module.exports = __webpack_public_path__ + "img/park-cover-1.cf229bb3.png";